module.exports = __webpack_public_path__ + "img/three.c3d044cb.png";